$(document).ready( () => {
  $('.carousel').carousel('pause')
})
